/** Keeps tab isolation without stripping the HTTP Referer header. */
export const EXTERNAL_LINK_REL = 'noopener';

export const isExternalHref = (href, origin) => {
  if (!href || typeof href !== 'string') return false;

  const trimmed = href.trim();
  if (
    trimmed.startsWith('#') ||
    trimmed.startsWith('mailto:') ||
    trimmed.startsWith('tel:') ||
    trimmed.startsWith('javascript:')
  ) {
    return false;
  }

  if (typeof window === 'undefined') {
    return /^https?:\/\//i.test(trimmed);
  }

  try {
    const url = new URL(trimmed, origin || window.location.origin);
    return (
      /^https?:$/i.test(url.protocol) &&
      url.origin !== (origin || window.location.origin)
    );
  } catch {
    return false;
  }
};

export const getLinkDomain = href => {
  try {
    const base =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'https://seelay.in';
    return new URL(href, base).hostname.replace(/^www\./, '');
  } catch {
    return '';
  }
};

export const getPageAnalyticsContext = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  return {
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    page_referrer: document.referrer || '(direct)',
  };
};

export const isMailtoOrTelHref = href => {
  if (!href || typeof href !== 'string') return false;
  const trimmed = href.trim().toLowerCase();
  return trimmed.startsWith('mailto:') || trimmed.startsWith('tel:');
};

export const isInternalHref = (href, origin) => {
  if (!href || typeof href !== 'string') return false;

  const trimmed = href.trim();
  if (
    !trimmed ||
    trimmed.startsWith('javascript:') ||
    isMailtoOrTelHref(trimmed) ||
    isExternalHref(trimmed, origin)
  ) {
    return false;
  }

  if (trimmed.startsWith('/') || trimmed.startsWith('#')) return true;

  if (typeof window === 'undefined') {
    return !/^https?:\/\//i.test(trimmed);
  }

  try {
    const url = new URL(trimmed, origin || window.location.origin);
    return url.origin === (origin || window.location.origin);
  } catch {
    return false;
  }
};

export const normalizeInternalPath = href => {
  if (!href || typeof href !== 'string') return '';

  if (typeof window === 'undefined') {
    return href.split('?')[0].split('#')[0] || href;
  }

  try {
    const url = new URL(href, window.location.origin);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return href;
  }
};
